<script>
    /*    Imports     */
    // import { onMount, onDestroy } from 'svelte';
    import { createEventDispatcher } from 'svelte';

    /* Props komponenty KalendarHeader */
    export let PocatecniDatumZobrazeni = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    export let PocetZobrazovanychMesicu = 3;

    /* Vlastnosti komponenty KalendarHeader */
    let sirkaOkna;

    const dispatch = createEventDispatcher();

    /* Funkce komponenty KalendarHeader */

    /**
     * Při změně šířky okna dochází k úpravě počtu zobrazovaných měsíců dle velikosti
    */
    $: if (sirkaOkna) 
    {
        if (sirkaOkna < 768) // Menší jak tablet (< 768 px)
        {
            PocetZobrazovanychMesicu = 1;
        }
        else if (sirkaOkna < 1024) // Menší jak Laptop (< 1024 px)
        {
            PocetZobrazovanychMesicu = 2;
        }
        else // Větší jak laptop (>= 1024 px)
        {
            PocetZobrazovanychMesicu = 3;
        }
    } 

    /**
     * Posune PocatecniDatumZobrazeni na první den předchozího měsíce této hodnoty
     * 
     * @returns {void} Nevrací nic, jedná se o proceduru
     */
    function PosunoutOMesicMene() 
    {
        const PuvodniDatum = PocatecniDatumZobrazeni;

        // Kontrola pro nový výpočet měsíce, roku (správné předání hodnot pro NoveDatum)
        const NovyMesic = ((PuvodniDatum.getMonth() + 11) % 12);
        const NovyRok = NovyMesic > PuvodniDatum.getMonth() ? 
            PuvodniDatum.getFullYear() - 1 : PuvodniDatum.getFullYear();

        const NoveDatum =  new Date(NovyRok, NovyMesic, 1);

        if(NoveDatum >= new Date(new Date().getFullYear(), new Date().getMonth(), 1)) 
        {
            // Pokud je nové datum po aktuálním datu, posune se prvek na nové datum
            PocatecniDatumZobrazeni = new Date(NovyRok, NovyMesic, 1);
            dispatch('posunMesiceZpet');
        }

    }

    /**
     * Posune PocatecniDatumZobrazeni na první den následujícího měsíce této hodnoty
     * 
     * @returns {void} Nevrací nic, jedná se o proceduru
     */
    function PosunoutOMesicVice()
    {
        const PuvodniDatum = PocatecniDatumZobrazeni;

        // Kontrola pro nový výpočet měsíce, roku (správné předání hodnot pro NoveDatum)
        const NovyMesic = ((PuvodniDatum.getMonth() + 13) % 12);
        const NovyRok = NovyMesic < PuvodniDatum.getMonth() ? 
            PuvodniDatum.getFullYear() + 1 : PuvodniDatum.getFullYear();

        const NoveDatum =  new Date(NovyRok, NovyMesic, 1);

        if(NoveDatum >= new Date()) 
        {
            // Pokud je nové datum po aktuálním datu, posune se prvek na nové datum
            PocatecniDatumZobrazeni = NoveDatum;
            dispatch('posunMesiceVpred');
        }

    }

    /**
     * Vytvoří array zobrazovaných měsíců
     * 
     * @param {Date} ZobrazovanyMesic - Zobrazovaný první měsíc (datum prvního dne daného měsíce)
     * @param {Number} PocetMesicu - Počet zobrazovaných měsíců pro vygenerování daného pole
     * 
     * @returns {Array<Date>} - První dny měsíců k zobrazení v headeru
    */
    function ZiskatPoleZobrazovanychMesicu(ZobrazovanyMesic, PocetMesicu) 
    {
        const PoleZobrazovanychMesicu = [];

        for(let i = 0; i < PocetMesicu; i++)
        {
            const DalsiMesic = ((ZobrazovanyMesic.getMonth() + 12 + i) % 12);
            const DalsiRok = DalsiMesic < ZobrazovanyMesic.getMonth() ?
                ZobrazovanyMesic.getFullYear() + 1 : ZobrazovanyMesic.getFullYear();

            PoleZobrazovanychMesicu.push(new Date(DalsiRok, DalsiMesic, 1));
        }

        return PoleZobrazovanychMesicu;
    }

</script>

<svelte:window bind:innerWidth={sirkaOkna}/>
<div class="kalendar-header">
    <button 
        on:click|preventDefault={() => PosunoutOMesicMene()}
        >
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="20" height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round" 
                class="feather feather-chevron-left"
            >
                    <polyline points="15 18 9 12 15 6"/>
            </svg>
    </button>
    <span>
        {
            ZiskatPoleZobrazovanychMesicu(PocatecniDatumZobrazeni, PocetZobrazovanychMesicu)
                .map(m => m.toLocaleString('cs-CZ', { month: 'long', year: 'numeric' }))
                .join(' • ')
        }
    </span>
    <button 
        on:click|preventDefault={() => PosunoutOMesicVice()}
        >
            <svg 
                xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round" 
                class="feather feather-chevron-right"
            >
                <polyline points="9 18 15 12 9 6"/>
            </svg>
    </button>
</div>

<style>
.kalendar-header 
{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1em;
}

.kalendar-header > button {
    /* -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    list-style-type: none!important;
    box-sizing: border-box;
    text-transform: uppercase; */
    font-size: 16px;
    /* cursor: pointer;
    position: relative;
    line-height: 1 !important;
    font-style: normal !important;
    vertical-align: middle;
    transition: .3s;
    text-shadow: none!important;
    font-family: Lato,Helvetica,Arial,sans-serif;
    text-align: center;
    font-weight: 700;
    text-decoration: none!important;
    display: block;
    letter-spacing: 0;
    color: #fff !important;
    border: 1px solid #bc9321;
    outline: 0;
    padding: 0.7em 1.5em;
    box-shadow: none !important;
    border-color: #bc9321;
    background: #bc9321;
    border-radius: 99em; */
}

.kalendar-header > button:hover 
{
    /* color: rgb(188, 147, 33) !important; */
    /* background: none !important;
    border-color: rgb(188, 147, 33) !important; */
}
</style>